import {Injectable} from "@angular/core";
import { HttpClient } from "@angular/common/http";
import {Observable} from "rxjs";
import { Role } from "../models/role.model";

@Injectable()
export class RoleService {
    private url = 'api/roles'

    constructor (private http: HttpClient) {}

    getRolesByUser(): Observable<Role[]> {
        return this.http.get<Role[]>(`${this.url}/user`);
    }

}